export default function KeyButton({
  children,
  onClick,
  testid,
  type = "button",
  disabled = false,
  compact = false,
  className = "",
}) {
  return (
    <button
      data-testid={testid}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`key-button inline-block select-none rounded-full font-mono-label text-[#2A2A28] disabled:opacity-50 ${
        compact
          ? "px-5 py-2.5 text-[10px] tracking-[0.2em]"
          : "px-8 py-3.5 text-[11px] tracking-[0.25em]"
      } ${className}`}
    >
      {children}
    </button>
  );
}
